(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bh3d-nation-menu-choices"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bh3d-nation-tabs')) {
  customElements.define('bh3d-nation-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) { this.observeMenu(); return; }
      this.ready = true;
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.querySelector('[role="tablist"]').addEventListener('click', (event) => {
        const tab = event.target.closest('[role="tab"]');
        if (this.tabs.includes(tab)) this.select(tab);
      });
      this.querySelector('[role="tablist"]').addEventListener('keydown', (event) => {
        const index = this.tabs.indexOf(event.target);
        if (index < 0 || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        event.stopPropagation();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
        this.select(this.tabs[next]);
        this.tabs[next].focus();
      });
      this.observeMenu();
    }
    observeMenu() {
      this.resetObserver?.disconnect();
      const era = this.closest('.js-mega-nav');
      const nation = this.closest('.child-nav__item--toggle');
      this.resetObserver = new MutationObserver((records) => {
        const opened = records.some((record) => {
          const previous = (record.oldValue || '').split(/\s+/);
          return ['is-open', 'is-visible'].some((name) => record.target.classList.contains(name) && !previous.includes(name));
        });
        if (opened && this.tabs[0]) this.select(this.tabs[0]);
      });
      [era, nation].filter(Boolean).forEach((element) => this.resetObserver.observe(element, { attributes: true, attributeFilter: ['class'], attributeOldValue: true }));
    }
    disconnectedCallback() {
      this.resetObserver?.disconnect();
    }
    select(selected) {
      this.tabs.forEach((tab) => {
        const active = tab === selected;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach((panel) => { panel.hidden = panel.id !== selected.getAttribute('aria-controls'); });
      const container = this.closest('.child-nav');
      const panel = this.closest('.child-nav__panel');
      if (container && panel && matchMedia('(min-width: 769px)').matches) {
        container.style.setProperty('--sidebar-height', panel.scrollHeight + 'px');
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
